import { FlujoTesoreriaGetConciliacionBancariaByIdDtoProps } from "api/DTOs/FlujoTesoreriaGetConciliacionBancariaByIdDto"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"

export const MODAL_DOCUMENTOS_CONCILIADAS_COLUMNS = (t: TFunction) => [
  {
    key: "identificador",
    field: "identificador",
    header: `${t(
      "bancos.conciliacion.rightColumn.conciliatedDocumentsTable.headerIdentificator"
    )}`,
    style: { width: "20%" },
  },
  {
    key: "descripcion",
    field: "descripcion",
    header: `${t(
      "bancos.conciliacion.rightColumn.conciliatedDocumentsTable.headerDescription"
    )}`,
    style: { width: "50%" },
  },
  {
    key: "importe",
    field: "importe",
    header: `${t(
      "bancos.conciliacion.rightColumn.conciliatedDocumentsTable.headerAmount"
    )}`,
    body: ({ importe }: FlujoTesoreriaGetConciliacionBancariaByIdDtoProps) =>
      importe ? frontendCurrency(importe) : "-",
    style: { width: "30%" },
    className: "!tw-text-end",
    alignCol: "right",
  },
]

export const MODAL_DOCUMENTOS_CONCILIADAS_COLUMNS_OLD = (t: TFunction) => [
  {
    key: "identificador",
    title: `${t(
      "bancos.conciliacion.rightColumn.conciliatedDocumentsTable.headerIdentificator"
    )}`,
    dataIndex: "identificador",
    className: "tw-text-base !tw-pl-6 [&>*_td]:!tw-py-0",
    width: "50%",
  },
  {
    key: "descripcion",
    title: `${t(
      "bancos.conciliacion.rightColumn.conciliatedDocumentsTable.headerDescription"
    )}`,
    dataIndex: "descripcion",
    className: "tw-text-base [&>*_td]:!tw-py-0",
    width: "50%",
  },
  {
    key: "importe",
    title: `${t(
      "bancos.conciliacion.rightColumn.conciliatedDocumentsTable.headerAmount"
    )}`,
    render: (cell: number) => frontendCurrency(cell),
    dataIndex: "importe",
    className: "tw-text-base tw-text-right !tw-pr-8 [&>*_td]:!tw-py-0",
    width: "50%",
  },
]
